import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Page/Home/Home";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Formulario from "./Page/Formulario/Formulario";
import Login from "./Page/Login/Login";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/home" element={<Home />} exact />
          <Route path="/create" element={<Formulario />} />
          <Route path="/" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
